import { chain } from '@leprecoins/effector';
import { sample } from 'effector';
import { debounce } from 'patronum';
import { accountTreeModel } from 'entities/account';
import { createPlayerTransactionRegistryModel } from 'entities/transaction';

export const playerTransactionRegistryModel = createPlayerTransactionRegistryModel({
	$allAccountIds: accountTreeModel.$nodes.map((nodes) => Object.values(nodes).map(({ id }) => id)),
});

sample({
	clock: debounce(accountTreeModel.$selectedNodes, 300),
	target: playerTransactionRegistryModel.registryModel.filters.accountIds.setValue,
});

chain(
	playerTransactionRegistryModel.registryModel.clearFilters,
	accountTreeModel.clearSelectedNodes,
);

export const playersTransactionPageModel = { playerTransactionRegistryModel };
